import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormArray, FormBuilder, FormGroup, Validators, SelectMultipleControlValueAccessor } from '@angular/forms';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { Conges } from '../../core/model/conges';
import { TypeConges } from '../../core/model/type-conges';
import { Employee } from '../../core/model/employee/employee';
import { TypeCongesService } from '../../core/service/type-conges.service';
import { CongesService } from '../../core/service/conges.service';
import { EmployeeService } from '../../core/service/employee.service';

@Component({
  selector: "app-edit-conges",
  templateUrl: "./edit-conges.component.html",
  styleUrls: ["./edit-conges.component.scss"],
})
export class EditCongesComponent implements OnInit {
  

  
  @Input() congeId;

  conge:Conges;
  types:TypeConges[];
  employees:Employee[]

  form2: FormGroup;
  pressButton:Boolean = false;
  
  
  dateDebutJson : any;
  
  constructor( 
    private _typeCongesService: TypeCongesService,
    private _congesService : CongesService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService,
    private _employeeService:EmployeeService
    ) 
    { 
      this.createForm();
    }

      
  createForm() 
  {
      this.form2 = this.fb.group({
        typeConge:[null, Validators.compose([Validators.required])],
        dateDebut:[null, Validators.compose([Validators.required])],
        nbreJour:[null, Validators.compose([Validators.required])],
        backupUsername:[null, Validators.compose([Validators.required])]
      });
  }



  ngOnInit() {
    this.getAllTypeConges();
    this.getCongeById(this.congeId);
    this.getAllEmployees();
  }


  
  getAllTypeConges()
  {
       this._typeCongesService.getAll()
       .subscribe(
           data => {
             debugger
             this.types =  data;
           },
           error => {
             console.log(error);
           });
  }

  
  getCongeById(congeId)
  {
       this._congesService.get(congeId)
       .subscribe(
           data => {
             this.conge =  data;
             this.dateDebutJson = this.convertDateStringToDateJson(this.conge.dateDebut)
           },
           error => {
             console.log(error);
           });
  }


  
  getAllEmployees()
  {
       this._employeeService.getEmployeesAllege()
       .subscribe(
           data => {
             this.employees =  data;
           },
           error => {
             console.log(error);
           });
  }



  save(): void {
        
    this.conge.dateDebut = this.convertDateJsonToDateString(this.dateDebutJson,{hour:0,minute:0});
    this.spinner.show();
      this._congesService.updateConge(this.conge)
      .pipe(first())
          .subscribe(
              data => {
                debugger
                this.spinner.hide();
                this.activeModal.close();
                ;
              },
              error => {
                console.log(error);
                this.spinner.hide();
          });
  } 


  

  convertDateStringToDateJson(date:string)
  {
    let dateSimple = new Date(date)
    let dateJson = {"year":dateSimple.getFullYear(),"month":dateSimple.getMonth()+1,"day":dateSimple.getDate()}
    return dateJson;
  }

  
convertDateJsonToDateString(date,time)
{
  let month;
  month = date.month;
  if(date.month<10)
  {
    month = "0"+date.month;
  }

  let day;
  day = date.day;
  if(date.day<10)
  {
    day = "0"+date.day;
  }

  //

  let hour;
  hour = time.hour;
  if(time.hour<10)
  {
    hour = "0"+time.hour;
  }
  
  let minute;
  minute = time.minute;
  if(time.minute<10)
  {
    minute = "0"+time.minute;
  }

  let datetime = date.year+"-"+month+"-"+day+"T"+hour+":"+minute
  return datetime;
}



  

  
}
